import React, { ReactNode } from "react";
import { ChevronArrowRight } from "../../../../assets/icons";
import { Link } from "react-router-dom";

interface BreadcrumbProps {
    items: Array<{ name: string, link: string }>
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
    items = []
}) => {
    return (
        <div className="inline-flex justify-start items-center gap-2">
            {
                items?.length && items.map((item: { name: string, link: string }, index: number) => <>
                    <Link to={item.link} className="px-2 py-1 flex cursor-pointer justify-center items-center text-[14px] font-bold text-neutral-25" key={index}>{item.name}</Link>
                    {items.length - 1 > index && <div className="breadcrumb-separator">
                        <ChevronArrowRight />
                    </div>}
                </>)
            }
        </div>
    )
}

export default Breadcrumb;

{/* <Link to={"/dashboard"}></Link> */ }